import React, { createContext, useState, useEffect } from 'react';
import { 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut 
} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, firestore } from '../firebase/config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // Surveiller l'état d'authentification
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        try {
          // Récupérer le profil utilisateur depuis Firestore
          const userDoc = await getDoc(doc(firestore, 'users', user.uid));
          if (userDoc.exists()) {
            setUserProfile(userDoc.data());
          }
        } catch (error) {
          console.error('Erreur lors de la récupération du profil:', error);
        }
      } else {
        setUserProfile(null);
      }
      
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, []);

  // Fonction de connexion
  const login = async (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  // Fonction d'inscription
  const register = async (email, password, name, firstname, phone) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Créer un profil utilisateur dans Firestore
    await setDoc(doc(firestore, 'users', user.uid), {
      uid: user.uid,
      email,
      name: name,
      firstname: firstname,
      phone,
      role: 'client', // Rôle par défaut
      createdAt: new Date().toISOString()
    });
    
    return userCredential;
  };

  // Fonction de réinitialisation de mot de passe
  const resetPassword = async (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  // Fonction de déconnexion
  const logout = async () => {
    return signOut(auth);
  };

  const value = {
    currentUser,
    userProfile,
    loading,
    login,
    register,
    resetPassword,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};